module.exports = __webpack_public_path__ + "static/img/Frame 1857.30af771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1857.png
// module id = 3a1K
// module chunks = 12